import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationStateShareService {

  private formState: number;

  constructor() {
    this.formState = 1;
  }

  getFormState(): number {
    return this.formState;
  }

  setFormState(state: number): void {
    this.formState = state;
  }
}
